import { Skeleton } from 'components/common/skeleton';

import './SkeletonRoom.css';
const SkeletonRoom = () => {
    return (
        <div className="ab-room--skeleton">
            <Skeleton width={195} height={'100%'} minWidth={195} />
            <div className="ab-room-middle-container--skeleton">
                <div className="ab-room-middle-upper--skeleton">
                    <div className="ab-room-upper-name--skeleton">
                        <Skeleton width={'100%'} height={24} mb={15} />
                    </div>

                    <div className="ab-room-upper-description--skeleton">
                        <Skeleton width={'100%'} height={12} />
                        <Skeleton width={'100%'} height={12} />
                        <Skeleton width={'100%'} height={12} />
                    </div>

                    <div className="ab-room-upper-notes--skeleton">
                        <Skeleton width={'85%'} height={12} />
                        <Skeleton width={'55%'} height={12} />
                    </div>
                </div>

                <div className="ab-room-middle-footer--skeleton">
                    <Skeleton width={'65%'} height={12} />
                </div>
            </div>
            <div className="ab-room-right-container--skeleton">
                <Skeleton width={'70%'} height={29} mb={5} />
                <Skeleton width={'80%'} height={12} mb={15} />

                <Skeleton width={'100%'} height={12} mb={5} />
                <Skeleton width={'85%'} height={12} mb={10} />

                <Skeleton width={'100%'} height={33} />
            </div>
        </div>
    );
};

export default SkeletonRoom;
